import React, { useState, useEffect } from 'react';
import helper from '../Shared/helper'
import defaultPhoto from '../Shared/photo_not_found.png'

const MatrixUserCard = ({userData, index}) => {
    const [apiURL, setApiURL] = useState('');
    const [photoError, setPhotoError] = useState(false);
    const [user, setUser] = useState({});
    const apiRootURL = helper.getProxyRootURL();
    
    useEffect(()=> {
        setApiURL(defaultPhoto)
        if(userData && userData.length) {
            setApiURL(`${apiRootURL}Photo/id=${userData.find((user) => user.key === 'personID').value}`)
        }

        if(userData) {
            const user = {
                personId: 0,
                name: '',
                status: '',
                modifiedDateTime: ''
            }

            let personId = userData.find((user) => user.key === 'personID')
            let name = userData.find((user) => user.key === 'firstName')
            let altName = userData.find((user) => user.key === 'alternateFirstName')
            let lastName = userData.find((user) => user.key === 'lastName')
            let status = userData.find((user) => user.key === 'status')
            let modifiedDateTime = userData.find((user) => user.key === 'modifiedDateTime')

            if(personId && personId.value && personId.value !== 0) {
                user.personId = personId.value
            }
            if(name && name.value) {
                user.name = name.value
            }
            if(altName && altName.value) {
                user.name += ` (${altName.value}) ` 
            }
            if(lastName && lastName.value) {
                user.name += ` ${lastName.value}` 
            }
            if(status && status.value) {
                if(status.value.toLowerCase() === 'active'){
                    user.status = 'Active'
                } else {
                    user.status = 'NOT Active'
                }
            }
            if(modifiedDateTime && modifiedDateTime.value) {
                user.modifiedDateTime = modifiedDateTime.value
            }
            setUser(user)
        }
      },[userData])

    return (
        <div className="user-card" key={index}>
            <div className='user-card-photo'>
                {userData && userData.length && !photoError
                    ? <img height={100} src={apiURL} onError={() => setPhotoError(true)} alt="Matrix User" />
                    : <img height={100} src={defaultPhoto} alt="No User Found" />
                }
            </div>
            <div className='user-card-data'>
                <p>{user.personId} - {user.status}</p>
                <p>{user.name}</p>
                <p>Last Modified:</p>
                <p>{user.modifiedDateTime}</p>
            </div>
        </div>
    );
}

export default MatrixUserCard;